//© 2025 Kaitlyn Troxell
import React from 'react';

function LoadingSpinner({ message = "Loading..." }) {
  return (
    <div className="loading-spinner-backdrop">
      <div className="loading-spinner-container">
        <div className="loading-spinner"></div>
        <p className="loading-spinner-message">{message}</p>
      </div>
    </div>
  );
}

export default LoadingSpinner;